<template lang="pug">
  router-link.card.c-hand(:to="to")
    .card-body
      .columns
        .column.col-auto(v-if="icon")
          i.fa-3x(:class="icon")
        .column
          .text-bold.mb-1.text-primary {{ title }}
          cite {{ subtitle }}
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    to: { type: Object, required: true },
    icon: { type: String },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../../styles/_variables.styl'

a.card
  text-decoration none
  color inherit
  transition all .2s ease
  *
    transition all .2s ease
  &:hover
    transform scale(1.02)
    i
      color primary-color-light
</style>
